exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ccm-client-settings--2rDdhgivQjUn2NqfR1T0MW {\n  height: 20px;\n  width: 20px;\n}\n", ""]);

// exports
exports.locals = {
	"spinner": "ccm-client-settings--2rDdhgivQjUn2NqfR1T0MW",
	"spinner": "ccm-client-settings--2rDdhgivQjUn2NqfR1T0MW"
};